import qs from 'qs'
import { getSession, setSession, removeSession } from './index'
import { OauthUserBindOpen, wxSignature } from '@/api/requests/UserRequests'
import { getTenantIdForWeixinAuth } from '@/utils/wxTenant' // 新增：统一获取 tenantId
const userAgent = navigator.userAgent.toLowerCase()

// wxf996e4080199a300
// snsapi_base snsapi_userinfo
const APPID = 'wx9cc7e3de31e28a63'
const scope = 'snsapi_userinfo'

interface ShareInfo {
  title: string
  desc: string
  link: string
  imgUrl: string
  success?: Function
  fail?: Function
}

const getCurrentUrl = (query: any) => {
  return `${window.location.href.split('?')[0]}${qs.stringify(query, {
    addQueryPrefix: true
  })}`
}
export const isWechat = /micromessenger/i.test(navigator.userAgent) && userAgent.indexOf('wxwork') === -1
export const isWechatFlag = /micromessenger/i.test(navigator.userAgent)
export const isComWx = /wxwork/i.test(navigator.userAgent) // 是否企业微信

const wxReady = () => {
  return new Promise((resolve) => {
    window.wx.ready(function () {
      resolve(true)
    })
  })
}

const jsApiList = [
  'updateAppMessageShareData',
  'updateTimelineShareData',
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'onMenuShareQQ',
  'onMenuShareQZone',
  'scanQRCode'
]

export default class Wxsdk {
  public query
  public configured
  constructor() {
    this.query = qs.parse(window.location.href.split('?')[1], { ignoreQueryPrefix: true })
    this.configured = false
    console.log('constructor-this.query', this.query)
  }

  init() {
    let localUser: any
    const env = process.env.VUE_APP_ENV
    if (!isWechat) {
      return Promise.resolve({})
    }
    if (env === 'test' || env === 'dev') {
      return Promise.resolve({})
    }
    localUser = getSession('wechat:user') || {}
    // 如果有存在unionId则认为已经授权过了，执行回调 && !localStorage.getItem('wechat:wxBind')
    if (localUser.unionId) {
      return Promise.resolve(localUser)
    }
    // 如果没有code则页面跳转进行授权 || localStorage.getItem('wechat:wxBind')
    if (!this.query.code) {
      console.log('location.href', location.href)
      console.log('this.query', this.query)
      const state = new Date().getTime()
      // if (options.disableAutoInit) {
      //   return Promise.resolve()
      // }
      setSession('wechat:state', state)
      // 链接添加_key防止微信缓存
      const hsQuery = qs.parse(window.location.hash.split('?')[1], { ignoreQueryPrefix: true })
      let q: any = { ...this.query, _key: +new Date(), ...hsQuery }
      let newHref = getCurrentUrl(q)
      console.log('newHref', newHref)
      window.location.replace(
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        APPID +
        '&redirect_uri=' +
        encodeURIComponent(newHref) +
        '&response_type=code&scope=' +
        scope +
        '&state=' +
        state +
        '#wechat_redirect'
      )
      return new Promise((r) => setTimeout(r.bind(null, {}), 2400))
    } else {
      // 如果有code需要 判断是不是已经用过的
      if (!this.validateState()) {
        return Promise.reject()
      }
      return this.fetchUser()
    }
  }

  trimCode() {
    const q = { ...this.query }

    q.state = undefined
    q.code = undefined
    const hash = window.location.href.split('#')[1] ? '#' + window.location.href.split('#')[1] : ''
    return getCurrentUrl(q) + hash
  }

  getState() {
    const state = getSession('wechat:state')
    removeSession('wechat:state')
    return state
  }

  validateState() {
    const localState = this.getState()
    let { state } = this.query
    state = state ? (state as string).split('#')[0] : state
    if (state || localState) {
      if (localState == state) {
        return true
      } else {
        window.location.replace(this.trimCode())
        return false
      }
    }
    return false
  }

  async fetchUser() {
    // 统一从工具函数获取（支持 relayTenantId、顶级域名 1000、二级域名缓存/接口）
    const tenantId = await getTenantIdForWeixinAuth()

    const reqParams = {
      code: this.query.code as string,
      type: 'wechat_public',
      getToken: 1,
      tenantId // 去掉硬编码 '1000' 的兜底，全部交由工具函数处理
    }
    try {
      let res = await OauthUserBindOpen(reqParams)
      const { userId, appId, openId, unionId, accessToken, authorizationCode, nickName, avatarUrl } = res.data
      let user: any = {
        userId,
        appId,
        openId,
        unionId,
        accessToken,
        authorizationCode,
        nickName,
        avatarUrl
      }
      this.setUser(user)
      return user
    } catch (err) {
      Promise.reject(err)
    }
  }

  getUser() {
    return getSession('wechat:user') || {}
  }

  setUser(user: any) {
    setSession('wechat:user', user)
  }

  // wx jssdk鉴权
  async setupConfig() {
    if (!isWechat) {
      return Promise.resolve()
    }
    // location.href.split('#')[0].split('?')[0]
    let res = await wxSignature({ url: window.location.href.split('#')[0] })
    const data = res?.data || {}
    window.wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: jsApiList || []
    })
    window.wx.error(function (err: any) {
      console.log('wx-error', err)
    })
    this.configured = true
    return Promise.resolve()
  }

  ready() {
    if (!isWechat) {
      return Promise.resolve('not in wx')
    }
    if (this.configured) {
      return wxReady()
    }
    return this.setupConfig().then(wxReady)
  }

  async wechatShare(shareInfo: ShareInfo) {
    await this.ready()
    const { title, desc, link, imgUrl } = shareInfo
    const shareParams = {
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: () => { },
      fail: () => { }
    }
    window.wx.updateAppMessageShareData(shareParams)
    window.wx.updateTimelineShareData(shareParams)
  }

  async wxscan() {
    await this.ready()
    window.wx.scanQRCode({
      needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res: any) {
        var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
        console.log(result)
      }
    })
  }
}
